import { render } from "./ArlaFooter.vue?vue&type=template&id=1252dffe&scoped=true"
import script from "./ArlaFooter.vue?vue&type=script&lang=js"
export * from "./ArlaFooter.vue?vue&type=script&lang=js"

import "./ArlaFooter.vue?vue&type=style&index=0&id=1252dffe&scoped=true&lang=scss"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1252dffe"]])

export default __exports__